import { useStoreQuery } from '@client/queries/useStoreQuery';
import {
  getRevenueBalance,
  getRevenueLedger,
  type IRevenueLedgerResponse,
} from '@client/services/revenue.service';

import type { IRevenueWallet } from '@common/types';

export const revenueKeys = {
  all: ['revenue'] as const,
  balance: () => [...revenueKeys.all, 'balance'] as const,
  ledgers: () => [...revenueKeys.all, 'ledger'] as const,
  ledger: (params: { limit: number; offset: number }) =>
    [...revenueKeys.ledgers(), params] as const,
};

export const useRevenueQueries = () => {
  const useBalance = () =>
    useStoreQuery<IRevenueWallet>({
      queryKey: revenueKeys.balance(),
      queryFn: getRevenueBalance,
    });

  const useLedger = (limit = 50, offset = 0) =>
    useStoreQuery<IRevenueLedgerResponse>({
      queryKey: revenueKeys.ledger({ limit, offset }),
      queryFn: () => getRevenueLedger(limit, offset),
    });

  return { useBalance, useLedger };
};
